import { inject } from '@vue/composition-api';

import { Dialog, DialogContext } from './Dialog';
import MessageDialog from './MessageDialog.vue';
import i18n from '../../i18n';

export function useDialog() {
  const currentDialog = inject(DialogContext);

  const dialog = Dialog.open;

  function confirmDialog(options) {
    const { title = i18n.t('common.notice'), message, showConfirmButton = true, showCancelButton } = options;
    return Dialog.open(MessageDialog, { message }, { title, showConfirmButton, showCancelButton });
  }

  function onConfirm(...args) {
    currentDialog && currentDialog.onConfirm(...args);
  }

  function onCancel(...args) {
    currentDialog && currentDialog.onCancel(...args);
  }

  function confirm(...args) {
    currentDialog && currentDialog.confirm(...args);
  }

  function cancel(...args) {
    currentDialog && currentDialog.cancel(...args);
  }

  function getCurrentDialog() {
    return currentDialog;
  }

  return {
    dialog,
    confirmDialog,
    onConfirm,
    confirm,
    onCancel,
    cancel,
    getCurrentDialog
  };
}
